import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "install-app-component" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-close" }, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-download" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args)), ["prevent"])),
      class: "close"
    }, _hoisted_3),
    _createElementVNode("p", null, _toDisplayString($setup.translate(`Install ${$setup.info.name}`)), 1 /* TEXT */),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-light",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.install && $setup.install(...args))),
      disabled: $setup.disabled
    }, [
      _hoisted_5,
      _createTextVNode(" " + _toDisplayString($setup.translate('Install')), 1 /* TEXT */)
    ], 8 /* PROPS */, _hoisted_4)
  ], 512 /* NEED_PATCH */)), [
    [_vShow, $setup.active]
  ])
}